import { lazyLoad } from '~/src/shared/utils/loadable';

export const MunicipalityCollaborationIshikawaPage = lazyLoad(
  () => import('./index'),
  (module) => module.MunicipalityCollaborationIshikawa,
);
